// extracted by mini-css-extract-plugin
export default {"-large":"nw8tohxBzGW09syXEHcO","dragHandle":"TRCZ0D6c3loPQLmR2r3M","modalStyles":"v9wSvF8zyyg2xe_XxZjv"};